import React from 'react';

export default function BookingDetailsCard({ booking, onMarkAsDelivered, onOpenReturnModal, onAcceptBooking, onDeclineBooking, onOpenInvoiceModal, error, onRequestFinalPayment, onStartChat, onOpenContractModal }) {
    const stopPropagation = (e) => e.stopPropagation();
    const bookingNumber = booking.bookingNumber || `BK-${booking.id.slice(0, 6).toUpperCase()}`;
    const displayItems = booking.manualOrderItems || [{
        description: booking.listingTitle,
        quantity: booking.quantity
    }];

    return (
        <div className="bg-gray-100 p-4 rounded-b-md border-t border-gray-200 animate-fade-in">
            <div className="flex justify-between items-center mb-4">
                <h4 className="font-bold text-md">Booking Details</h4>
                {booking.renterId.startsWith('manual_') && (
                    <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">Manual Order</span>
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div>
                    <p><span className="font-semibold">Booking #:</span> {bookingNumber}</p>
                    <p><span className="font-semibold">Fulfillment:</span> <span className="capitalize">{booking.deliveryMethod}</span></p>
                    {booking.deliveryMethod === 'delivery' && (
                        <>
                            <p><span className="font-semibold">Address:</span> {booking.deliveryAddress}</p>
                            <p><span className="font-semibold">Time:</span> {booking.deliveryTime ? new Date(`1970-01-01T${booking.deliveryTime}`).toLocaleTimeString([], {hour: 'numeric', minute:'2-digit'}) : 'Flexible'}</p>
                        </>
                    )}
                </div>
                <div className="md:col-span-2">
                    <p className="font-semibold">Items:</p>
                    <ul className="list-disc list-inside text-gray-600">
                        {displayItems.map((item, index) => (
                            <li key={index}>{item.quantity} x {item.description}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200 flex justify-end items-center space-x-2">
                {error && <p className="text-red-500 text-sm font-semibold mr-2">{error}</p>}
                
                <button
                    onClick={(e) => { e.stopPropagation(); onStartChat(booking); }}
                    disabled={booking.isGuestBooking}
                    title={booking.isGuestBooking ? "Cannot message a guest user" : "Message Renter"}
                    className="bg-blue-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-blue-600 font-semibold disabled:bg-gray-400"
                >
                    Message Renter
                </button>
                
                {!['pending', 'cancelled', 'declined'].includes(booking.status) && (
                    <>
                        <button onClick={(e) => { stopPropagation(e); onOpenContractModal(booking); }} className={`px-3 py-1 rounded-lg text-sm font-semibold text-white ${booking.contractStatus === 'signed' ? 'bg-green-600 hover:bg-green-700' : booking.contractStatus === 'sent' ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-600 hover:bg-gray-700'}`}>
                            {booking.contractStatus === 'signed' ? 'View Contract' : booking.contractStatus === 'sent' ? 'Contract Sent' : 'Generate Contract'}
                        </button>
                        <button onClick={(e) => { e.stopPropagation(); onOpenInvoiceModal(); }} className="bg-gray-600 text-white px-3 py-1 rounded-lg text-sm hover:bg-gray-700 font-semibold">
                            {booking.invoiceGeneratedAt ? 'View Invoice' : 'Generate Invoice'}
                        </button>
                    </>
                )}
                 {booking.status === 'pending' && (
                    <>
                        <button onClick={(e) => { stopPropagation(e); onDeclineBooking(booking); }} className="bg-red-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-red-600 font-semibold">Decline</button>
                        <button onClick={(e) => { stopPropagation(e); onAcceptBooking(booking); }} disabled={!!error} className="bg-green-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-green-600 font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed">Accept</button>
                    </>
                 )}
                 {booking.status === 'paid' && <button onClick={(e) => { stopPropagation(e); onMarkAsDelivered(booking.id, booking.renterId, booking.listingTitle); }} className="bg-blue-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-blue-600 font-semibold">Mark as Delivered</button>}
                 {booking.status === 'deposit-paid' && <button onClick={(e) => { stopPropagation(e); onRequestFinalPayment(booking); }} className="bg-purple-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-purple-600 font-semibold">Request Final Payment</button>}
                 {['awaitingPlannerConfirmation', 'delivered', 'awaitingPickup'].includes(booking.status) && <button onClick={(e) => { stopPropagation(e); onOpenReturnModal(booking); }} className="bg-green-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-green-600 font-semibold">Confirm Return</button>}
            </div>
        </div>
    );
}